import Select from 'react-select';
import React, { useState, useEffect } from 'react'
import ToastNotification from '../../../components/ToastNotification';
import axios from 'axios'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver"; 
import { MdLocalPrintshop } from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import html2canvas from "html2canvas";
import { useLoading } from '../../../context/LoadingContext';
import { toWords } from "number-to-words";

function CRMDocument({adminData,companyID,branchID}) {


  const { setLoading } = useLoading();
     const [noteType, setNoteType] = useState(null);
  const [fetchData, setfetchData] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [branchDetail, setBranchDetail] = useState([])
   const [showDownloadModal, setShowDownloadModal] = useState(false);
     const [selectedQuotation, setSelectedQuotation] = useState(null);
  const[company,setCompany] = useState([]);
const [showPDFModal, setShowPDFModal] = useState(false);
const [inventoryItems, setInventoryItems] = useState([]);
const [quotationData, setQuotationData] = useState(null);

  
  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };


  const reportOptions = [
      { value: 'sales_enquiry', label: 'Sales Enquiry' },

  ]


  const documentConfig = {
  sales_enquiry: {
    title: "Sales Enquiry",
    prefix: "SE",
  },

  followup: {
    title: "Followup",
    prefix: "FLW",
  },


};


const isMaterial = (type) =>
  ["sales_enquiry", "followup"].includes(type);


const numberToWords = (amount) => {
  if (!amount) return "";

  const num = Number(amount);
  if (isNaN(num)) return "";

  const words = toWords(num);

  return words
    .replace(/-/g, " ") 
    .split(" ")
    .filter(Boolean)
    .map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");
};

    const fetchBranchDetail = async () => {
      setLoading(true)
    try {
      const resInventory = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
       setBranchDetail(resInventory.data)

    } catch (error) {
      console.log(error)
    } finally {
     setLoading(false);
        }
  };


    const fetchCompany = async () => {
      setLoading(true)
    try {
      const res = await axios.get(`https://api.skyguard.group/api/fetch-company-localData/${companyID}`);
      setCompany(res.data);

    } catch (error) {
      console.log(error)
    } finally {
     setLoading(false);
        }
  };

  const fetchInventoryDetail = async () => {
    try {
        const resInventory = await axios.get(
            'https://api.skyguard.group/api/fetch-inventory'
        );

        setInventoryItems(resInventory.data.result);
        console.log(resInventory.data.result);
    } catch (error) {
        console.log(error);
    }
};


   useEffect(() => {
  
      fetchBranchDetail();
      fetchCompany();
      fetchInventoryDetail();
    }, []);



const handleSearch = async (e) => {
  e.preventDefault();

  try {
    const params = {
      note_type: noteType?.value,
      from_date:fromDate,
      to_date:toDate
    };


    const result = await axios.get(
      'https://api.skyguard.group/api/get-crm-document',
      { params }
    );

    const resultData = result?.data?.result || [];
     console.log('list',resultData);


    setfetchData(resultData);

 

    if (resultData.length > 0) {
      setToast('Report fetched successfully', 'success');
    } else {
      setToast('No data found in selected date range', 'warning');
    }

  } catch (error) {
    console.error('❌ Error fetching report:', error);
    setToast('Error fetching report. Please try again.', 'danger');
  }
};



    const handleExportExcel = () => {
      const table = document.getElementById("exportTable");
    
      if (!table) return;
    
      const worksheet = XLSX.utils.table_to_sheet(table);
      const workbook = XLSX.utils.book_new();
    
      XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");
    
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
    
      const data = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
    
      saveAs(data, "CRM_Document.xlsx");
    };


    
const handlePrint = () => {
  const printContents = document.getElementById("invoice-print-area").innerHTML;
  const originalContents = document.body.innerHTML;

  // Open a new window for printing
  const printWindow = window.open("", "_blank", "width=900,height=600");
  printWindow.document.write(`
    <html>
      <head>
     
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          table { border-collapse: collapse; width: 100%; }
          table, th, td { border: 1px solid #000; }
          th, td { padding: 5px; text-align: center; }
          .text-start { text-align: left; }
        </style>
      </head>
      <body>
        ${printContents}
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
  printWindow.close();
};

// const handleDownloadPDF = () => {
//   const doc = new jsPDF("p", "mm", "a4");

//   doc.setFontSize(16);
//   doc.text("Sale Documents Report", 14, 15);

//   let tableColumn = [];
//   let tableRows = [];

//   // Different table structure based on selected type
//   if (noteType?.value === "sale_quotation") {
//     tableColumn = [
//       "Doc No",
//       "Date",
//       "Party",
//       "Address",
//       "Item",
//       "Rate",
//       "Description",
//       "Added By",
//       "Created At",
//     ];

//     fetchData.forEach((item) => {
//       let items = [];

//       try {
//         items = JSON.parse(item.items || "[]");
//       } catch {
//         items = [];
//       }

//       const itemNames = items
//         .map((it) => `${it.name} (Qty:${it.qty})`)
//         .join(", ");

//       const rates = items.map((it) => it.rate).join(", ");

//       const rowData = [
//         `SQ/${item.inv_no}/${item.branchId}`,
//         item.payment_date,
//         item.party_name,
//         item.party_address,
//         itemNames,
//         rates,
//         item.remark,
//         `${item.emp_first || ""} ${item.emp_middle || ""} ${item.emp_last || ""}`,
//         item.created_at,
//       ];

//       tableRows.push(rowData);
//     });
//   }

//   autoTable(doc, {
//     head: [tableColumn],
//     body: tableRows,
//     startY: 25,
//     styles: {
//       fontSize: 8,
//       cellPadding: 2,
//     },
//     headStyles: {
//       fillColor: [41, 128, 185],
//     },
//   });

//   doc.save("Sale_Report.pdf");
// };


const handleSaveMergedPDF = async () => {

  const pdf = new jsPDF("p", "mm", "a4");

  const pages = document.querySelectorAll(".pdf-page");

  for (let i = 0; i < pages.length; i++) {

    const canvas = await html2canvas(pages[i], {
      scale: 2,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/png");

    const imgWidth = 210;

    const imgHeight =
      (canvas.height * imgWidth) / canvas.width;

    if (i > 0) {
      pdf.addPage();
    }

    pdf.addImage(
      imgData,
      "PNG",
      0,
      0,
      imgWidth,
      imgHeight
    );
  }

  pdf.save("All_CRM_Document.pdf");
};

const getItemName = (itemId) => {
  const foundItem = inventoryItems.find(
    (inv) => Number(inv.id) === Number(itemId)
  );

  return foundItem?.name || "Unknown Item";
};

  return (
      <div className='main-section'>
          <ToastNotification
            show={toast.show}
            message={toast.message}
            bg={toast.bg}
            onClose={() => setToast({ ...toast, show: false })}
          />
          <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
  
            <h3 className='my-3 fw-bold fs-5 golos'>CRM Documents</h3>
  
  
            <div className="row g-3 align-items-end">
              <div className="col-md-4">
                <label className='fw-bold'>Select Document</label>
                <Select
                  options={reportOptions}
                  placeholder="Choose Type ..."
                  id="source"
                  value={noteType}
  
                  onChange={(selected) => {
                    setNoteType(selected);
                    setfetchData([]);
                  }}
                />
              </div>
  
              <div className="col-md-4">
                <label className='fw-bold'>From Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="from_date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
  
              <div className="col-md-4">
                <label className='fw-bold'>To Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="to_date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
  
  
              <div className="col-md-12 d-flex justify-content-end align-items-end">
                {/* <button className="btn btn-primary" onClick={handleSearch} >Search</button> */}
                 <FaSearch size={26} className="ms-1 text-primary"
                                style={{ cursor: "pointer" }}
                                title="Search"
                                onClick={handleSearch}
                              />
                
                              <MdLocalPrintshop
                                size={26}
                                className="ms-1 text-success me-1"
                                   onClick={handleExportExcel}
                                style={{ cursor: "pointer" }}
                                title="Print "
                              />
  
                            <button
    className='btn btn-warning'
    onClick={() => setShowPDFModal(true)}
  >
    Download PDF
  </button>
              </div>
            </div>
  
            <div id="exportTable" className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
              {isMaterial(noteType?.value) && (
                <table  className='table table-bordered table-striped table-hover text-center align-middle'>
                  <thead className='table-info'>
                    <tr>
                      <th>Enquiry No</th>
                      <th>Enquiry Date</th>
                        <th>Party Name</th>
                        <th>Item</th>
                        <th>Consultant </th>
                        <th>Sale Person</th>
                        
                    
                    </tr>
                  </thead>
                  <tbody>
               {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData.map((item, idx) => {
  
      let items = [];
      try {
        items = JSON.parse(item.table_row || "[]");
      } catch (e) {
        items = [];
      }


         const totalAmount = items.reduce(
        (sum, it) => sum + Number(it.amount || 0),
        0
      );
  
      return (
        <tr key={idx}>
  
        

   <td>{`${documentConfig?.[noteType?.value]?.prefix}/${item.id}/${item.branchId || item.from_branch_code}`}</td>
  
          <td>{item.quotation_date}</td>
  
          
          <td>{item.party_name || ""}   </td>
  
      <td style={{ whiteSpace: "nowrap" }}>
  {JSON.parse(item.table_row || "[]").map((row, i) => (
    <div key={i}>
      {getItemName(row.item)} (Qty: {row.qty}) 
    </div>
  ))}
</td>
  
 
             
          <td>{item.cood_first || ""} {item.cood_middle || ""} {item.cood_last || ""}  </td>

          
  
        <td>{item.sp_first || ""} {item.sp_middle || ""} {item.sp_last || ""}  </td>
  

  
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="9">No data found</td>
    </tr>
  )}
                  </tbody>
                </table>
              )}
  
            </div>
  
  
{showPDFModal && (
  <div
    className="position-fixed top-0 start-0 w-100 h-100"
    style={{
      background: "rgba(0,0,0,0.6)",
      zIndex: 9999,
      overflowY: "auto",
      padding: "20px",
    }}
  >

    {/* TOP ACTION BAR */}
    <div
      style={{
        width: "210mm",
        margin: "0 auto 10px auto",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "#fff",
          padding: "12px 20px",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        }}
      >

        <h3
          style={{
            margin: 0,
            fontWeight: "700",
            color: "#222",
          }}
        >
          Preview {documentConfig?.[noteType?.value]?.title}
        </h3>

        <div style={{ display: "flex", gap: "10px" }}>

          <button
            className="btn btn-success"
            onClick={handleSaveMergedPDF}
          >
            Save PDF
          </button>

          <button
            className="btn btn-danger"
            onClick={() => setShowPDFModal(false)}
          >
            Close
          </button>

        </div>

      </div>
    </div>

    {/* PDF CONTENT */}
    <div id="all-bills-pdf">

      {fetchData.map((quotation, index) => {

        let parsedRows = [];

        try {
          parsedRows = JSON.parse(quotation.table_row || "[]");
        } catch {
          parsedRows = [];
        }

        return (

          <div
            key={index}
            className="pdf-page"
            style={{
              width: "210mm",
              minHeight: "297mm",
              margin: "5px auto",
              background: "#fff",
              padding: "12mm",
              boxSizing: "border-box",
              pageBreakAfter: "always",
              fontFamily: "Arial",
            }}
          >

            {/* COMPANY HEADER */}
            <div
              style={{
                textAlign: "center",
                marginBottom: "20px",
                borderBottom: "2px solid #000",
                paddingBottom: "10px",
              }}
            >

              <div
                style={{
                  fontSize: "26px",
                  fontWeight: "700",
                  textTransform: "uppercase",
                }}
              >
                {company?.name || "Company Name"}
              </div>

              <div
                style={{
                  fontSize: "13px",
                  marginTop: "5px",
                  whiteSpace: "pre-line",
                }}
              >
                {company?.address}
              </div>

              <div
                style={{
                  fontSize: "13px",
                  marginTop: "5px",
                }}
              >
                GSTIN : {company?.gst}
              </div>

              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  marginTop: "12px",
                  textDecoration: "underline",
                }}
              >
                {documentConfig?.[noteType?.value]?.title}
              </div>

            </div>

            {/* MAIN FORM */}
            <div
              style={{
                border: "1px solid #000",
                fontSize: "13px",
              }}
            >

              {/* ROW 1 */}
              <div
                style={{
                  display: "flex",
                  borderBottom: "1px solid #000",
                }}
              >

                <div
                  style={{
                    width: "50%",
                    padding: "8px",
                    borderRight: "1px solid #000",
                  }}
                >
                  <strong>Enquiry No :</strong>
                  {" "}
                  {quotation.id}
                </div>

                <div
                  style={{
                    width: "50%",
                    padding: "8px",
                  }}
                >
                  <strong>Date :</strong>
                  {" "}
                  {quotation.quotation_date}
                </div>

              </div>

              {/* ROW 2 */}
              <div
                style={{
                  display: "flex",
                  borderBottom: "1px solid #000",
                }}
              >

                <div
                  style={{
                    width: "50%",
                    padding: "8px",
                    borderRight: "1px solid #000",
                  }}
                >
                  <strong>Sales Engineer :</strong>
                  {" "}
                  {quotation.sp_first}
                  {" "}
                  {quotation.sp_middle}
                  {" "}
                  {quotation.sp_last}
                </div>

                <div
                  style={{
                    width: "50%",
                    padding: "8px",
                  }}
                >
                  <strong>Date of Site Visit :</strong>
                  {" "}
                  {quotation.visite_date}
                </div>

              </div>

              {/* CUSTOMER */}
              <div
                style={{
                  borderBottom: "1px solid #000",
                  padding: "8px",
                }}
              >
                <strong>Customer Name :</strong>
                {" "}
                {quotation.party_name}
              </div>

              {/* PHONE */}
              <div
                style={{
                  borderBottom: "1px solid #000",
                  padding: "8px",
                }}
              >
                <strong>Phone :</strong>
                {" "}
                {quotation.party_phone}
              </div>

              {/* ARCHITECT + CONSULTANT */}
              <div
                style={{
                  display: "flex",
                  borderBottom: "1px solid #000",
                }}
              >

                <div
                  style={{
                    width: "50%",
                    padding: "8px",
                    borderRight: "1px solid #000",
                  }}
                >
                  <strong>Architect :</strong>
                  <div>{quotation.architect}</div>
                </div>

                <div
                  style={{
                    width: "50%",
                    padding: "8px",
                  }}
                >
                  <strong>Consultant :</strong>
                  <div>{quotation.consultant}</div>
                </div>

              </div>

              {/* QUOTATION TO */}
              <div
                style={{
                  borderBottom: "1px solid #000",
                  padding: "8px",
                }}
              >
                <strong>Quotation To Be Sent To :</strong>
                {" "}
                {quotation.quotation_to}
              </div>

              {/* ITEM TABLE */}
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                }}
              >

                <thead>

                  <tr>

                    <th
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "left",
                        width: "80%",
                      }}
                    >
                      Description
                    </th>

                    <th
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "center",
                        width: "20%",
                      }}
                    >
                      Qty
                    </th>

                  </tr>

                </thead>

                <tbody>

                  {parsedRows.map((row, i) => (

                    <tr key={i}>

                      <td
                        style={{
                          border: "1px solid #000",
                          padding: "8px",
                        }}
                      >
                        {getItemName(row.item)}
                      </td>

                      <td
                        style={{
                          border: "1px solid #000",
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        {row.qty}
                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          </div>

        );
      })}
    </div>

    {/* PRINT CSS */}
    <style>
      {`
        @media print {
          .pdf-page {
            margin: 0;
            box-shadow: none;
          }
        }
      `}
    </style>

  </div>
)}
  

          </div>
        </div>
  )
}

export default CRMDocument